module.exports = __webpack_public_path__ + "static/media/silver_cufflinks_coat_of_arms_result.a8c68d24.jpg";